	import { createSlice } from "@reduxjs/toolkit";

function omitEmptyAndMinusOneFields(obj) {
	const result = {};
	for (const key in obj) {
		// Exclude null, undefined, empty string, and -1 values
		if (
			obj[key] !== null &&
			obj[key] !== undefined &&
			obj[key] !== "" &&
			obj[key] >= 0 &&
			obj[key] !== "-1"
		) {
			result[key] = obj[key];
		}
	}
	return result;
}
export const agentFilterSlice = createSlice({
	name: "agentFilter",
	initialState: {
		formData: {
			operatorId: localStorage.getItem("user")
				? JSON.parse(localStorage.getItem("user")).operator_id
				: "",
			firstName: "",
			lastName: "",
			agentMobile: "",
			partnerId: -2,
			partnerBranchId: -2,
			withApp: -2,
			agentStatus: -2,
			verifiedStatus: -2,
			signupDateFrom: new Date(),
			signupDateInto: new Date(),
		},
		agentResultList: [],
		allDate: true,

		withLockerNameState: false,
	},
	reducers: {
		handleChangeFilterData: (state, actions) => {
			const { name, value, maxLength } = actions.payload;
			const regex = /^[0-9]+/;
			if (
				(name === "agentMobile" && regex.test(value)) ||
				value === "" || // Check for agentMobile and only numbers
				(value.length <= maxLength && name !== "agentMobile") ||
				(!maxLength &&
					(name === "partnerId" ||
						name === "partnerBranchId" ||
						name === "withApp" ||
						name === "agentStatus" ||
						name === "verifiedStatus"))
			) {
				return {
					...state,
					formData: {
						...state.formData,
						[name]: value,
					},
				};
			} else if (name === "signupDateFrom" || name == "signupDateInto") {
				return {
					...state,
					formData: {
						...state.formData,
						[name]: value,
					},
				};
			} else {
				return state;
			}
		},
		handleSubmitFilterData: (state) => {
			const user = localStorage.getItem("user")
				? JSON.parse(localStorage.getItem("user"))
				: null;
			const tempState = {
				operatorId: user ? user.operator_id : "",
				firstName: state.formData.firstName || "",
				lastName: state.formData.lastName || "",
				agentMobile: state.formData.agentMobile || "",
				partnerId:
					state.formData.partnerId !== -1 ? state.formData.partnerId : -2,
				partnerBranchId:
					state.formData.partnerBranchId !== -1
						? state.formData.partnerBranchId
						: -2,
				withApp: state.formData.withApp !== 0 ? state.formData.withApp : -2,
				agentStatus:
					state.formData.agentStatus !== -2 ? state.formData.agentStatus : -2,
				verifiedStatus:
					state.formData.verifiedStatus !== -1
						? state.formData.verifiedStatus
						: -2,

				// signupDateFrom: "",
				signupDateInto: state.formData.signupDateInto,
				// allDate: state.allDate,
				signupDateFrom:
					state.allDate === true ? "" : state.formData.signupDateFrom,
				// signupDateInto: allDate ? "" : state.formData.signupDateInto || "",
			};
			state.formData = tempState;
		},
		getAgentResultList: (state, actions) => {
			const agentsWithFilter = actions.payload;
			var tempData = [];
			if (agentsWithFilter) {
				tempData = agentsWithFilter.map((element) => {
					const objectData = { ...element }; // Create a new object or clone the existing one

					if (objectData.agentStatus === 0) {
						objectData.agentStatus = "Suspended";
					} else if (objectData.agentStatus === 1) {
						objectData.agentStatus = "Active";
					} else if (objectData.agentStatus === -1) {
						objectData.agentStatus = "Blocked";
					} else {
						objectData.agentStatus = "Unknown";
					}

					if (objectData.verifiedStatus === 0) {
						objectData.verifiedStatus = "Unverified";
					} else if (objectData.verifiedStatus === 1) {
						objectData.verifiedStatus = "Verified";
					} else if (objectData.verifiedStatus === 2) {
						objectData.verifiedStatus = "Pending Verification";
					} else if (objectData.verifiedStatus === 3) {
						objectData.verifiedStatus = "Rejected";
					} else {
						objectData.verifiedStatus = "Unknown";
					}

					return objectData; // Return the modified object
				});
				state.agentResultList = tempData;
			}
		},
		setWithLockerNameReducer: (state, actions) => {
			state.withLockerNameState = actions.payload;
		},
		setAllDateFilterReducer: (state, actions) => {
			state.allDate = actions.payload;
			// If allDate is true, clear the date fields
			if (actions.payload === true) {
				state.formData.signupDateFrom = "";
				state.formData.signupDateInto = "";
			} else {
				// If allDate is false, reset to the current date if fields are empty
				if (!state.formData.signupDateFrom) {
					state.formData.signupDateFrom = new Date();
				}
				if (!state.formData.signupDateInto) {
					state.formData.signupDateInto = new Date();
				}
			}
		},
		revertAgentFilter: (state, actions) => {
			state.formData = actions.payload;
		},
		resetAgentFilter: (state) => {
			state.formData = {
				operatorId: localStorage.getItem("user")
					? JSON.parse(localStorage.getItem("user")).operator_id
					: "",
				firstName: "",
				lastName: "",
				agentMobile: "",
				partnerId: -2,
				partnerBranchId: -2,
				withApp: -2,
				agentStatus: -2,
				verifiedStatus: -2,
				// signupDateFrom: new Date(),
				// signupDateInto: new Date(),
			};
			state.allDate = true;
			state.withLockerNameState = false;
		},
	},
});

export const {
	handleChangeFilterData,
	handleSubmitFilterData,
	getAgentResultList,
	setWithLockerNameReducer,
	setAllDateFilterReducer,
	revertAgentFilter,
	resetAgentFilter,
} = agentFilterSlice.actions;

export default agentFilterSlice.reducer;
